import { client } from "api";
import { Company } from "models/Company";

export type DenyCompanyRequest = {
  companyId: string;
  reason?: string;
};

export type DenyCompanyResponse = Company;

export const denyCompany = ({ companyId, reason }: DenyCompanyRequest) =>
  client.post<DenyCompanyResponse>(`/company/${companyId}/deny`, { reason }).then((res) => res.data);
